<template>
    <div
        class="absolute left-4 top-4 z-50 h-auto max-h-72 w-[calc(100%_-_2rem)] border border-black-text bg-white px-4 shadow-md md:h-auto md:max-h-none md:w-1/5 md:min-w-[300px]"
        :class="{
            'overflow-hidden': collapsed,
            'bottom-32 overflow-y-auto': !collapsed,
            'pointer-events-none invisible opacity-0': !store.selectedMetrika,
            'pointer-events-auto visible opacity-100': store.selectedMetrika,
        }"
    >
        <div
            class="sticky top-0 flex items-center justify-start gap-2 border-b border-black-text bg-white py-2 font-promedium duration-200"
            :class="{
                'border-b-0': collapsed,
            }"
        >
            <i
                class="pi pi-angle-down cursor-pointer duration-200"
                :class="{ 'rotate-180': collapsed }"
                @click="collapsed = !collapsed"
            />
            <span @click="collapsed = !collapsed">{{
                useLocaleValue(store.selectedMetrika, "NAZEV_UDAJE")
            }}</span>
            <div class="ml-auto">
                <div
                    class="cursor-pointer text-sm"
                    @click="store.selectedMetrika = null"
                >
                    <Icon name="custom:close" />
                </div>
            </div>
        </div>
        <div
            ref="content"
            class="duration-200"
            :class="{
                'visible opacity-100': !collapsed,
                'invisible opacity-0': collapsed,
            }"
        >
            <div
                class="pt-4 font-proregular text-sm"
                v-html="useLocaleValue(store.selectedMetrika, 'ANOTACE')"
            />

            <TagItemList
                :content="keywords"
                type="klic_slova"
                size="sm"
                class="mb-1 mt-2"
            />
            <TagItemList
                :content="store.selectedMetrika?.SKUPINA_VRSTEV_ATLAS"
                type="atlas"
                size="sm"
                class="mb-1 mt-2"
            />
            <TagItemList
                :content="store.selectedMetrika?.KOD_METRIKY_KMEC"
                type="metriky"
                size="sm"
                class="mb-1 mt-2"
            />
            <!-- <div
                v-if="store.selectedMetrika?.NAZEV_UDAJE_DATA"
                class="mb-2 mt-4 font-proregular text-sm"
            >
                {{ $t("klok.ref_hodnoty") }}:
            </div> -->
            <div class="mb-4 mt-4 grid grid-cols-2 gap-x-3 text-sm">
                <KlokRefValuesTable
                    :attr-name="'DLAZDICE_REF_MESTO'"
                    :tooltip-attr-name="'TOOLTIP_REF_MESTO'"
                />
                <KlokRefValuesTable
                    :attr-name="'DLAZDICE_REF_TYP_STRUKTURY'"
                    :tooltip-attr-name="'TOOLTIP_REF_TYP_STRUKTURY'"
                />
            </div>
            <div class="mb-1 mt-2 font-promedium text-sm">
                {{ $t("klok.legenda") }}
            </div>
            <div
                v-if="renderer && renderer.type === 'simple'"
                class="flex flex-col gap-0.5"
            >
                <div
                    v-for="el in (
                        renderer.visualVariables?.at(0) as __esri.ColorVariable
                    ).stops"
                    :key="el.label as string"
                    class="flex items-center gap-2"
                >
                    <div
                        class="h-3 w-3 rounded-full"
                        :style="{ backgroundColor: el.color.toCss() }"
                    />
                    <div
                        class="font-proregular text-xs"
                        v-html="useLocaleValue(el, 'label')"
                    />
                </div>
            </div>
            <div
                v-if="renderer && renderer.type === 'unique-value'"
                class="flex flex-col gap-0.5"
            >
                <div
                    v-for="el in renderer.uniqueValueInfos"
                    :key="el.label as string"
                    class="flex items-center gap-2"
                >
                    <div
                        class="h-3 w-3 rounded-full"
                        :style="{ backgroundColor: el.symbol?.color?.toCss() }"
                    />
                    <div
                        class="font-proregular text-xs"
                        v-html="useLocaleValue(el, 'label')"
                    />
                </div>
            </div>
            <div class="mt-4 font-proregular text-sm">
                {{ $t("klok.garance") }}:
                <a href="mailto:uap@ipr.praha.eu">{{ $t("general.kam") }}</a>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const store = useKlokStore()

const renderer = computed(() => {
    if (!store.selectedMetrika) return
    const item = useKlokRenderer(
        store.selectedMetrika.NAZEV_UDAJE_DATA.split(",")[0]
    )
    return item
})

const keywords = computed(() => {
    if (!store.selectedMetrika || !store.selectedMetrika.KLICOVA_SLOVA_ID)
        return []
    return store.selectedMetrika.KLICOVA_SLOVA_ID.split(",").map(el =>
        parseInt(el)
    )
})

const content = ref<HTMLDivElement>()
const collapsed = ref(false)
watch(collapsed, () => {
    if (content.value) {
        const height = content.value.scrollHeight
        content.value.style.height = collapsed.value ? "0" : height + "px"
    }
})
</script>

<style scoped></style>
